import React from "react";

const Contact = () => {
  return (
    <div className="section" id="contact">
    </div>
  );
};

export default Contact;
